import { Outlet } from "react-router";

export default function TokensPage() {
   return (
       <Outlet />
   );
}
